const {Component} = require("react");
const PropTypes = require("prop-types");
const IMask = require("imask/dist/imask");
const assign = require("object-assign");
const {pluckKeysExcept} = require("helpers/object");
const {methodNotImplemented} = require("helpers/errors");

class Price extends Component {

	static get propTypes() {
		return {
			currency: PropTypes.string,
			handleChange: PropTypes.func
		};
	}

	static get defaultProps() {
		return {
			currency: "DKK"
		};
	}

	constructor(props) {
		super(props);

		this.state = {
			value: props.value || props.defaultValue || ""
		};
	}

	componentWillReceiveProps(props) {
		if (props.value) {
			this.setState({value: props.value}, () => {
				this.input.value = this.state.value;
				this.mask.updateValue();
				this.mask.updateControl();
			});
		}
	}

	get className() {
		let classList = ["price-field"];

		if (typeof this.props.className === "string") {
			classList.push(this.props.className);
		}

		return classList.join(" ");
	}

	get inputProps() {
		return assign(
			pluckKeysExcept(
				this.props,
				Object.keys(this.constructor.propTypes).concat(["value", "defaultValue", "inputRef", "onInput", "name"])
			),
			{type: "text", pattern: "[0-9,.]+"}
		);
	}

	_setInputRef = (el) => {
		this.input = el;

		if (typeof this.props.inputRef === "function") {
			this.props.inputRef(el);
		}
	};

	handleChange = () => {
		if (typeof this.props.handleChange === "function") {
			this.props.handleChange(this.state.value);
		}
	};

	_onInput = (e) => {
		let value = e.target.value.replace(".", "").replace(",", ".");

		if (value[value.length - 1] === ".") {
			value = value.substr(0, value.length - 1);
		}

		this.setState({
			value: value.length > 0 ? parseFloat(value) : ""
		}, this.handleChange);
	};

	componentDidMount() {
		this.mask = window.theMask = new IMask(this.input, {
			mask: Number,
			scale: 2,
			signed: false,
			thousandsSeparator: ".",
			padFractionalZeros: true,
			normalizeZeros: true,
			min: 0,
			max: 99999999.99,
			mapToRadix: ["."]
		});
	}

	render() {
		throw methodNotImplemented("render");
	}

}

module.exports = Price;


// WEBPACK FOOTER //
// ./resources/js/components/abstract/Price.js